<template>
  <div :class="['data-grid-group-cell', {'divider': divider}]"
       v-if="configs && configs.length">
    <CompositeTableActionCell v-for="(config, index) in configs"
                              :key="'group-cell-' + index"
                              :table-column="config"
                              v-bind="$attrs"
                              v-on="$listeners">
      <template slot-scope="{renderAction, renderActionText, renderActionIcon}">
        <DataGridGroupCellText v-if="renderActionText"
                               :config="config"
                               :render-action="renderAction"
                               :render-action-text="renderActionText"
                               :render-action-icon="renderActionIcon"></DataGridGroupCellText>
      </template>
    </CompositeTableActionCell>
  </div>
</template>

<script>
import CompositeTableActionCell from '../../elements/grid/CompositeTableActionCell'
import DataGridGroupCellText from './wrapper/DataGridGroupCellText'
export default {
  name: 'DataGridGroupCell',
  components: {
    CompositeTableActionCell,
    DataGridGroupCellText
  },
  props: {
    tableColumn: {
      type: Object,
      required: true
    }
  },
  computed: {
    cell: function () {
      let renderCell = this.tableColumn.renderCell
      if (renderCell) {
        let cellType = renderCell.cellType
        if (cellType) {
          return cellType.cell
        }
      }
    },
    configs: function () {
      let cell = this.cell
      if (cell) {
        let configs = cell.configs
        if (configs) {
          return configs.map(config => {
            // 需要从列中继承的属性
            config.prop = this.tableColumn.prop
            return config
          })
        }
      }
    },
    divider: function () {
      let cell = this.cell
      if (cell) {
        return cell.divider
      }
    }
  }
}
</script>

<style lang="scss">
  .data-grid-group-cell {
    display: inline;
    &.divider {
      .grid-cell {
        .data-grid-group-cell-text {
          position: relative;
          padding-left: 5px;
          padding-right: 5px;
        }
        & + .grid-cell {
          .data-grid-group-cell-text {
            &:before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              width: 1px;
              height: 10px;
              margin-top: -5px;
              background-color: #ddd;
            }
          }
        }
      }
    }
    .grid-cell {
      .data-grid-group-cell-text {
        padding-left: 2px;
        padding-right: 2px;
      }
    }
  }
</style>
